import React from "react";
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { withStyles } from '@mui/styles';
import { styled } from '@mui/system';

import DashboardTemplate from "../components/templates/DashboardTemplate";
import MixpanelOnload from "../components/MixpanelOnload";

//import PaymentIcon from '@mui/icons-material/PaymentIcon';
import KiaraLogo from '../img/kiara_logo_icon_red.png';
//const moment = require('moment');

const useStyles = theme => ({
    '@global': {
    },
    paper: {
        padding: '8px',
    }
});

const SpacedCardContent = styled(CardContent)(({ theme }) => ({
    '& > *:not(:last-child)': {
        marginBottom: theme.spacing(3),
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}));

class ChangeFinish extends React.Component {

    constructor() {
        super();
        this.state = {
        };
    }

    componentDidMount() {
        //this.getAccount();
    }

    prependItems = () => {
        return <div />
    }
    appendItems = () => {
        return <div />
    }

    render() {
        // TODO change trial finish date
        return (
            <DashboardTemplate maxWidth="xl" prependItems={this.prependItems()} appendItems={this.appendItems()}>
                <div>
                    <CardContent align="center" >
                        <SpacedCardContent>
                            <Typography variant="h4" component="p">
                                Your change has been completed.
                            </Typography>
                            <p>
                                Need support? Please check out our <a href="https://www.getkiara.com/help/category/faq">FAQ</a>.<br />
                                For more information, talk to us by chat, <a href="https://www.getkiara.com/contact">form</a> or to hello@kiara.team
                            </p>
                            <img src={KiaraLogo} alt="kiara logo" style={{ 'width': '250px' }} />
                        </SpacedCardContent>
                    </CardContent>
                    <MixpanelOnload message="kiara-app.com/change-finish" />
                </div>
            </DashboardTemplate>
        )
    }
}
export default withStyles(useStyles)(ChangeFinish);
